<template>
	<v-card flat>
		<v-card-text class="d-sm-none">
			<h3 class="mb-3">Позиции</h3>
			<v-divider />
		</v-card-text>
		<repair-order-positions-table
			:order-id="order.id"
			:positions="parts"
			type="part"
			@created="$emit('created', $event)"
			@deleted="$emit('deleted', $event)"
		>
			<template #title>Запчасти</template>
			<template #empty>Не добавлено ни одной запчасти</template>
		</repair-order-positions-table>
		<repair-order-positions-table
			:order-id="order.id"
			:positions="works"
			type="work"
			:default-price="order.rate_per_hour"
			@created="$emit('created', $event)"
			@deleted="$emit('deleted', $event)"
		>
			<template #title>Работы</template>
			<template #empty>Не добавлено ни одной работы</template>
		</repair-order-positions-table>
	</v-card>
</template>

<script>
import RepairOrderPositionsTable from '@/components/orders/repair/show/positions-table';

export default {
	name: 'RepairOrderPositions',
	components: {
		RepairOrderPositionsTable,
	},
	props: {
		order: {
			type: Object,
			required: true,
		},
		positions: {
			type: Array,
			required: true,
		},
	},
	computed: {
		parts() {
			return this.positions.filter(position => position.type === 'part');
		},
		works() {
			return this.positions.filter(position => position.type === 'work');
		},
	},
};
</script>

<style scoped>

</style>
